module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_8003.8645d5af.png";